/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import React, { useEffect, useState, useRef } from 'react';
import JoditEditor from "jodit-react";
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Modal, Toast, Popover, OverlayTrigger } from 'react-bootstrap';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import CountdownBanner from './Components/CountdownBanner';
import Form from './Components/StorySubmissionForm';
import FormJsonData from './JSON/FormData/Story';
import data from './JSON/structure.json';
import ReCAPTCHA from "react-google-recaptcha";

const strucKey = 'struckey';
const grid = 8;
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    margin: `0 0 ${grid}px 0`,
    border: isDragging ? "1px solid #033369" : "none",

    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    height: isDraggingOver ? '180px' : 'auto'

});

class CustomLayout extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            FormJsonData: FormJsonData.data,
            component: data.structure,
            addRowModal: false,
            addColItemsModal: false,
            editImageModal: false,
            editedRow: '',
            editedCol: '',
            uploadedImages: [],
            QuestionList: [],
            NoOfImageUsed: [],
            NoOfQuestionUsed: [],
            QuestionInRow: [],
            SubmittedData: "",
            alertBox: false,
            CreateConfirmationModal: false,
            file: "",
            config: "",
            redirectToHome: false,
            errorMessage: "",
            isSubmitted: false,
            recaptchaVal: "",
            Preview: {
                title: '',
                description: '',
                countryTag: '',
                projectTag: '',
                schoolTag: '',
                themeTag: '',
                imgPreview: '',
                leaderName: '',
                startDate: '',
                endDate: '',
                fbLink: '',
                igLink: '',
            },
            expandImage: 0,
            zoomVal: 100,
            isPreview: false,
            loading: false
        };
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        this.addRow = this.addRow.bind(this);
        this.addImage = this.addImage.bind(this);
        this.addQuestion = this.addQuestion.bind(this);
        this.addText = this.addText.bind(this);
        this.handleAddRowModal = this.handleAddRowModal.bind(this);
        this.handleAddColItemModal = this.handleAddColItemModal.bind(this);
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.handleEditImageModal = this.handleEditImageModal.bind(this);
        this.sunEditorUpdate = this.sunEditorUpdate.bind(this);
        this.hideShowContent = this.hideShowContent.bind(this);
        this.deleteContent = this.deleteContent.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.stylingSubmit = this.stylingSubmit.bind(this);
        this.checkDataFromForm = this.checkDataFromForm.bind(this);
        this.FileUpload = this.FileUpload.bind(this);
        this.handleCreateConfirmationModal = this.handleCreateConfirmationModal.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.toggleAlertBox = this.toggleAlertBox.bind(this);
        this.addNewStory = this.addNewStory.bind(this);
        this.GoToPreview = this.GoToPreview.bind(this);
        this.recaptchaOnChange = this.recaptchaOnChange.bind(this);
        this.captchaExpired = this.captchaExpired.bind(this);

        this.expandImage = this.expandImage.bind(this);
        this.Zoom = this.Zoom.bind(this);
    }

    GoToPreview(obj) {
        this.setState({ isPreview: !this.state.isPreview, Preview: obj });
        //localStorage.setItem('struckey', JSON.stringify(this.state.component));
    }

    recaptchaOnChange(value) {
        this.setState({ recaptchaVal: value });
    }

    captchaExpired() {
        this.setState({ recaptchaVal: "" });
    }

    FileUpload(file) {
        this.setState({ file: file });
    }

    handleCreateConfirmationModal() {
        this.setState({ CreateConfirmationModal: !this.state.CreateConfirmationModal });
    }

    expandImage() {
        var expandImage = this.state.expandImage;

        if (this.state.expandImage >= 1) {
            expandImage = 0;
        } else {
            expandImage = 1;
        }
        this.setState({ expandImage: expandImage })
    }

    Zoom(action) {
        var zoomSize;

        var zoomVal = this.state.zoomVal;
        if (action === 'increase') {
            if (zoomVal <= 180) {
                zoomSize = zoomVal + 20;
                this.setState({ zoomVal: zoomSize })

            }
        } else {
            if (zoomVal >= 40) {
                zoomSize = zoomVal - 20;
                this.setState({ zoomVal: zoomSize })

            }
        }

    }

    checkDataFromForm(obj, isAbleToSubmit) {
        const recaptchaValue = this.state.recaptchaVal;
        //var struckey = localStorage.getItem('struckey') ? JSON.parse(localStorage.getItem('struckey')) : [];
        var struckey = this.state.component.length > 0 ? this.state.component : [];
        var checkTextCount = [];
        struckey.forEach(function (row, index) {
            row.items.forEach(function (object, index) {
                if (object.type === 'text' || object.type === 'question') {
                    var word_count = object.content.replace(/(<([^>]+)>)/gi, " ").replace(/\r?\n|\r/g, " ").replace('&nbsp;', '').trim().split(/\s+/).length;
                    if (word_count < 150) {
                        checkTextCount.push(false);
                    }
                }

            });
        });

        if (isAbleToSubmit && this.state.NoOfQuestionUsed.length >= 5 && this.state.NoOfImageUsed.length >= 5 && recaptchaValue) {
            this.setState({ CreateConfirmationModal: true, SubmittedData: obj, errorMessage: "" });
        } else {
            if (!isAbleToSubmit) {
                this.setState({ errorMessage: "Please fill in all mandatory fields!" });
            } else if (struckey.length <= 0) {
                this.setState({ errorMessage: "Please answer 5 questions and attach 5 images in the story body!" });
            } else if (this.state.NoOfQuestionUsed.length < 5) {
                this.setState({ errorMessage: "Please answer 5 questions in the story body!" });
            } else if (this.state.NoOfImageUsed.length < 5) {
                this.setState({ errorMessage: "Please attach 5 images in the story body!" });
            } else if (checkTextCount.length > 0) {
                this.setState({ errorMessage: "Minimum 150 words for all text fields in the story body" });
            } else if (!recaptchaValue) {
                this.setState({ errorMessage: "Please do the recaptcha!" });
            }
            // this.setState({ errorMessage: "Please fill in all mandatory fields, answer 5 questions and attach 5 images in the story body and each question must have at least 150 words!" });
        }
    }

    toggleAlertBox() {
        this.setState({ alertBox: !this.state.alertBox });
    }

    getQuestion() {
        fetch(this.state.apiUrl + '/ChallengeAPI/GetQuestion', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Question_ID": null,
                    "Challenge_ID": null
                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ QuestionList: data.QuestionDetail });

            })
            .catch(console.log);
    }

    addNewStory() {
        this.setState({ CreateConfirmationModal: false, loading: true });
        let obj = this.state.SubmittedData;
        var structure = {
            structure: this.state.component
        }
        this.setState({ isSubmitted: true });

        fetch(this.state.apiUrl + '/StoryAPI/CreateStory', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "Story_ID": null,
                "Story_Title": obj.Story_Title ? obj.Story_Title : "",
                "Story_Description": obj.Story_Description ? obj.Story_Description : "",
                "Story_UserEmail": obj.Story_UserEmail ? obj.Story_UserEmail : "",
                "Story_IsPublish": 1,
                "Challenge_ID": null,
                "Other_LeaderName": obj.Other_LeaderName ? obj.Other_LeaderName : "",
                "Contact_Name": obj.Contact_Name ? obj.Contact_Name : "",
                "Trip_StartDate": obj.Trip_StartDate ? obj.Trip_StartDate : "",
                "Trip_EndDate": obj.Trip_EndDate ? obj.Trip_EndDate : "",
                "Country_ID": obj.Country_ID,
                "Project_ID": obj.Project_ID,
                "School_ID": obj.School_ID,
                "Theme_ID": obj.Theme_ID,
                "Story_FacebookURL": obj.Story_FacebookURL,
                "Story_InstagramURL": obj.Story_InstagramURL,
                "Story_Layout": JSON.stringify(structure)
            })
        })
            .then(res => res.json())
            .then(storyId => {
                if (this.state.uploadedImages.length > 0) {
                    const csFileFormData = new FormData();
                    const files = this.state.uploadedImages;
                    csFileFormData.append('ID', storyId);

                    for (var i = 0; i <= parseInt(files.length) - 1; i++) {
                        csFileFormData.append('File', files[i]);
                    }

                    fetch(this.state.apiUrl + '/StoryAPI/UploadFileStoryLayout', {
                        method: 'POST',
                        headers: {
                            'token': process.env.REACT_APP_API_TOKEN,
                            'access-control-allow-origin': '*'
                        },
                        body: csFileFormData
                    })
                        .then(res => res.json())
                        .then((csFileData) => {
                            const fileForm = new FormData();
                            fileForm.append('ID', storyId);
                            fileForm.append('File', this.state.file);

                            fetch(this.state.apiUrl + '/StoryAPI/UploadFileStory', {
                                method: 'POST',
                                headers: {
                                    'token': process.env.REACT_APP_API_TOKEN,
                                    'access-control-allow-origin': '*'
                                },
                                body: fileForm
                            })
                                .then(res => res.json())
                                .then((fileData) => {
                                    this.setState({ redirectToHome: true, loading: false });
                                })
                                .catch((error) => {
                                    this.setState({ loading: false });
                                    console.error('Error:', error);
                                });
                        })
                        .catch((error) => {
                            this.setState({ loading: false });
                            console.error('Error:', error);
                        });
                } else {
                    const fileForm = new FormData();
                    fileForm.append('ID', storyId);
                    fileForm.append('File', this.state.file);

                    fetch(this.state.apiUrl + '/StoryAPI/UploadFileStory', {
                        method: 'POST',
                        headers: {
                            'token': process.env.REACT_APP_API_TOKEN,
                            'access-control-allow-origin': '*'
                        },
                        body: fileForm
                    })
                        .then(res => res.json())
                        .then((fileData) => {
                            this.setState({ redirectToHome: true, loading: false });
                        })
                        .catch((error) => {
                            this.setState({ loading: false });
                            console.error('Error:', error);
                        });
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    stylingSubmit(e) {
        e.preventDefault();
        var updateItem = data.structure[this.state.editedRow].items[this.state.editedCol];
        var width = this.Width.value;
        var height = this.Height.value;
        updateItem.style = [width, height];
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        this.setState({ component: data.structure, handleEditImageModal: false });

    }

    deleteRow(index) {
        var NoOfQuestionUsed = this.state.NoOfQuestionUsed;
        var QuestionInRow = this.state.QuestionInRow;
        var NoOfImageUsed = this.state.NoOfImageUsed;
        var updateItem = data.structure[index];

        updateItem.items.forEach(function (rowItem, rowIndex) {
            if (rowItem.type === 'question') {
                var x = QuestionInRow.length - 1;
                QuestionInRow.forEach(function (item, itemIndex) {
                    if (item.row === index) {
                        NoOfQuestionUsed.splice(NoOfQuestionUsed.indexOf(item.questionId), 1)
                    }
                });

                while (x >= 0) {
                    //console.log(QuestionInRow[x].row);
                    if (QuestionInRow[x].row === index) {
                        QuestionInRow.splice(x, 1);
                    }
                    x--;
                }

                QuestionInRow.forEach(function (item, itemIndex) {
                    if (item.row > index) {
                        item.row = parseInt(item.row) - 1;
                    }
                });
            } else if (rowItem.type === 'image') {
                NoOfImageUsed.pop();
            }
        });


        data.structure.splice(index, 1);
        this.setState({ component: data.structure, NoOfQuestionUsed: NoOfQuestionUsed, QuestionInRow: QuestionInRow, NoOfImageUsed: NoOfImageUsed });
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
    }

    deleteContent(index1, index2) {
        var NoOfImageUsed = this.state.NoOfImageUsed;
        var NoOfQuestionUsed = this.state.NoOfQuestionUsed;
        var QuestionInRow = this.state.QuestionInRow;
        var updateItem = data.structure[index1].items[index2];
        if (updateItem.type === 'image') {
            NoOfImageUsed.pop();
        } else if (updateItem.type === 'question') {
            QuestionInRow.forEach(function (item, index) {
                if (item.row === index1 && item.col === index2) {
                    QuestionInRow.splice(index, 1);
                    NoOfQuestionUsed.splice(NoOfQuestionUsed.indexOf(item.questionId), 1)
                }
            });
        }
        updateItem.type = '';
        updateItem.content = '';

        this.setState({ component: data.structure, NoOfQuestionUsed: NoOfQuestionUsed, QuestionInRow: QuestionInRow, NoOfImageUsed: NoOfImageUsed });
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
    }

    sunEditorUpdate(value, index1, index2) {
        var updateItem = data.structure[index1].items[index2];
        updateItem.content = value;
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        this.setState({ component: data.structure, addColItemsModal: false });
        // this.setState({ hideShowText: true });
    }

    hideShowContent(index1, index2) {
        var updateItem = data.structure[index1].items[index2];
        updateItem.editor = !updateItem.editor;
        this.setState({ component: data.structure });
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        // this.setState({ hideShowText: !this.state.hideShowText });
    }

    addQuestion(event) {
        var QuestionInRow = this.state.QuestionInRow;
        var rowInfo = {
            "row": this.state.editedRow,
            "col": this.state.editedCol,
            "questionId": event.target.value
        }
        var NoOfQuestionUsed = this.state.NoOfQuestionUsed;
        var updateItem = data.structure[this.state.editedRow].items[this.state.editedCol];
        updateItem.type = 'question';
        updateItem.editor = true;
        updateItem.question = event.target.options[event.target.selectedIndex].text;
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        NoOfQuestionUsed.push(event.target.value);
        QuestionInRow.push(rowInfo);
        this.setState({ component: data.structure, addColItemsModal: false, NoOfQuestionUsed: NoOfQuestionUsed, QuestionInRow: QuestionInRow });
    }

    addText() {
        var updateItem = data.structure[this.state.editedRow].items[this.state.editedCol];
        updateItem.type = 'text';
        updateItem.editor = true;
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        this.setState({ component: data.structure, addColItemsModal: false });
    }

    addImage() {
        var NoOfImageUsed = this.state.NoOfImageUsed;
        var updateItem = data.structure[this.state.editedRow].items[this.state.editedCol];
        updateItem.type = 'image';
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
        NoOfImageUsed.push(0);
        this.setState({ component: data.structure, addColItemsModal: false, NoOfImageUsed: NoOfImageUsed });
    }

    handleImageUpload(e, file, index1, index2) {
        // var FormData = new FormData();
        // FormData.append('ID', 10);
        if (file && file[0]) {
            var fileName = file[0].name.split('.').slice(0, -1).join('.');
            var re = /^[0-9a-zA-Z\_\- ]+$/;
            if (re.test(fileName)) {
                var imageSize = (file[0].size / 1024 / 1024).toFixed(2);
                if (imageSize <= 2) {
                    var uploadedImages = this.state.uploadedImages;
                    var structure = data.structure;
                    var updateItem = structure[index1].items[index2];
                    //if (!uploadedImages.includes(file[0].name)) {
                    // updateItem.content = process.env.REACT_APP_FILEUPLOAD_PRODUCTION_URL + file[0].name;
                    updateItem.content = process.env.REACT_APP_FILEUPLOAD_PRODUCTION_URL + file[0].name;
                    uploadedImages.push(file[0]);
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        //updateItem.content = e.target.result;
                        updateItem.previewContent = e.target.result;
                        document.querySelector("#img" + index1 + index2).setAttribute('src', e.target.result);
                    }
                    reader.readAsDataURL(e.target.files[0]);

                    this.setState({ component: structure, uploadedImages: uploadedImages });
                    //localStorage.setItem('struckey', JSON.stringify(data.structure));
                }
            } else {
                e.target.value = "";
                alert("A file name cannot contain any of the following characters \\ / : * ? \" < > | # { } % ~ &");
            }
        }
        // } else {
        //     window.alert('Same file name');
        // }
    }

    addRow(numRow) {
        var strucLength = data.structure.length + 1;
        var rows;
        if (numRow === 1) {
            rows = [{
                "classname": "col-md-12 position-relative",
                "type": "",
                "style": "",
                "content": "",
                "previewContent": "",
                "question": "",
                "editor": true,
                "order": 0
            }];
        } else {
            rows = [{
                "classname": "col-md-6 position-relative",
                "type": "",
                "style": "",
                "content": "",
                "previewContent": "",
                "question": "",
                "editor": true,
                "order": 1
            }, {
                "classname": "col-md-6 position-relative",
                "type": "",
                "style": "",
                "content": "",
                "previewContent": "",
                "question": "",
                "editor": true,
                "order": 2
            }];
        }

        var newStructure = data.structure.push({
            "id": strucLength.toString(),
            "classname": "row position-relative mb-2",
            "order": strucLength,
            "items": rows
        });
        this.setState({ component: newStructure, addRowModal: false });
        //localStorage.setItem('struckey', JSON.stringify(data.structure));
    }

    handleAddRowModal() {
        this.setState({ addRowModal: !this.state.addRowModal });
    }

    handleEditImageModal(index1, index2) {
        this.setState({ editedRow: index1, editedCol: index2, editImageModal: !this.state.editImageModal });
    }

    handleAddColItemModal(index1, index2) {
        this.setState({ editedRow: index1, editedCol: index2, addColItemsModal: !this.state.addColItemsModal });
    };

    onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const items = reorder(
            data.structure,
            result.source.index,
            result.destination.index
        );
        console.log(data.structure, result.source.index, result.destination.index);
        this.setState({ component: items });
        localStorage.setItem('struckey', JSON.stringify(items));
    }

    componentDidMount() {
        this.getQuestion();
        localStorage.removeItem('struckey');
        FormJsonData.data.forEach(function (items1, itemIndex) {
            items1.value = "";
            items1.touched = false;
            items1.isOtherField = false;
            items1.otherField.value = "";
            items1.otherField.touched = "";
        });

        this.setState({
            config: {
                removeButtons: ['source', 'strikethrough', 'superscript', 'subscript', 'brush', 'image', 'file', 'video', 'symbol', 'fullsize', 'print', 'preview', 'find', 'about', 'table', 'paragraph'],
                height: 300,
                showXPathInStatusbar: false,
                showCharsCounter: false,
                showWordsCounter: true,
                toolbarAdaptive: false
            }
        });
    }

    render() {
        const struc_data = data.structure ? data.structure : [];
        const NoOfImageUsed = this.state.NoOfImageUsed;
        var isAbleToAddImage = NoOfImageUsed.length <= 4 ? false : true;

        const PreviewAsset = this.state.Preview;
        const isExpand = this.state.expandImage === 0 ? '400px' : this.state.expandImage === 1 ? '600px' : '';
        const isBG = this.state.expandImage ? this.state.zoomVal + '% auto' : 'cover';
        //const dataStruc = this.state.component;
        if (this.state.redirectToHome) {
            //return <Redirect to={'/'} />
            window.location.href = process.env.REACT_APP_STORY_REDIRECT;
        }

        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Instructions and Notes</Popover.Title>
                <Popover.Content>
                    <ol className="list-unstyle pl-3">
                        <li className="mb-2">Complete all 5 questions and submit 5 photos from your YEP or YEP-GO.</li>
                        <li className="mb-2">While selecting Add Row, choose 1 column or 2 columns to build your story layout. You can refer to approved stories for examples.</li>
                        <li className="mb-2">While selecting Add Column, choose answer questions or add an image to input text or pictures. More text is an optional choice after you have completed 5 questions and added 5 photos.</li>
                    </ol>
                </Popover.Content>
            </Popover>
        );

        return (
            <div className="CustomLayout">
                <CountdownBanner />
                { this.state.loading && <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(192,192,192,0.5)', top: 0, zIndex: 1 }}>
                    <span><img src="images/loading.gif" alt="loading" className="icon-loading" /> Submitting Story...</span>
                </div>}
                {this.state.isPreview && <div className="preview position-fixed w-100 h-100 bg-light overflow-auto" style={{ zIndex: 999, top: 0 }}>
                    <div className="Container-fluid">
                        <div className="row m-0">
                            <div className="col-md-12 p-0 preview-control bg-dark">
                                <div className="position-relative" style={{ width: '100%', 'height': isExpand, 'backgroundImage': 'url(' + PreviewAsset.imgPreview + ')', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center center', 'backgroundSize': isBG, minHeight: '400px', transition: 'all 500ms' }}>
                                    {/* <div className="d-flex align-items-center mr-3 bg-light"><img src="images/slice/2.stories/stories/icons/icon-heart.png" className="img-fluid" /></div> */}
                                    <div className="position-absolute d-flex justify-content-end align-items-center w-100 mt-2" style={{ top: 0 }}>
                                        {/* <button className="btn btn-pink mt-5">Vote!</button><br /> */}
                                        <button type="button" onClick={() => this.GoToPreview()} className="btn btn-outline-light mr-2">Back to form</button>

                                    </div>
                                    <div className="position-absolute d-flex justify-content-center align-items-center w-100 mb-2" style={{ bottom: 0 }}>
                                        {/* <button className="btn btn-pink mt-5">Vote!</button><br /> */}

                                        <button onClick={this.expandImage} className="btn btn-secondary mr-2">VIEW IMAGE</button>
                                        {this.state.expandImage === 1 && <div>
                                            <a onClick={() => this.Zoom('increase')} className="mr-2 cursor_pointer"><img alt="zoomIn" src="images/zoom_in.png" /></a>
                                            <a onClick={() => this.Zoom('decrease')} className="mr-2 cursor_pointer"><img alt="zoomOut" src="images/zoom_out.png" /></a>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row mt-3">
                                <div className="col-12 py-3 py-md-0 d-flex justify-content-end align-items-center">
                                    <div className="pl-3">
                                        {PreviewAsset.fbLink && <a target="_blank" rel="noopener noreferrer" href={PreviewAsset.fbLink}><img src="./images/facebook.png" alt="facebook" className="icons-social mr-2" /></a>}
                                        {PreviewAsset.igLink && <a target="_blank" rel="noopener noreferrer" href={PreviewAsset.igLink}><img alt="instagram" src="./images/instagram.png" className="icons-social" /></a>}
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-5 mb-2">
                                <div className="col-md-12 text-center">
                                    <h3 style={{ 'color': '#254D7C', wordBreak: 'break-word' }} className="text-Gotham font-weight-bold">{PreviewAsset.title}</h3>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-12 text-center text-Gotham font-weight-bold">
                                    <p dangerouslySetInnerHTML={{ __html: PreviewAsset.description }}></p>
                                </div>
                            </div>
                            {PreviewAsset.leaderName && <div className="row mb-2">
                                <div className="col-md-12 text-center text-Gotham font-weight-bold" style={{ 'font-size': '14px' }}>
                                    <small>Leader Name: {PreviewAsset.leaderName}</small>
                                </div>
                            </div>}
                            {PreviewAsset.startDate && PreviewAsset.endDate && <div className="row mb-2">
                                <div className="col-md-12 text-center text-Gotham font-weight-bold" style={{ 'font-size': '14px' }}>
                                    <small>{PreviewAsset.startDate}&nbsp; to &nbsp;{PreviewAsset.endDate}</small>
                                </div>
                            </div>}

                            {/* <div className="row mb-3">
                        <div className="col-md-12 text-center">
                            <h3>Team Lorem Ipsum</h3>
                        </div>
                    </div> */}
                            <div className="row mb-3">
                                <div className="col-md-12 d-md-flex flex-row justify-content-center">
                                    {PreviewAsset.countryTag && <div className="text-light py-1 px-3 storyTag countryTag mr-2 mb-2">
                                        {PreviewAsset.countryTag ? PreviewAsset.countryTag : ''}
                                    </div>}
                                    {PreviewAsset.schoolTag && <div className="text-light py-1 px-3 storyTag schoolTag mr-2 mb-2">
                                        {PreviewAsset.schoolTag ? PreviewAsset.schoolTag : ''}
                                    </div>}
                                    {PreviewAsset.projectTag && <div className="text-light py-1 px-3 storyTag projectTag mr-2 mb-2">
                                        {PreviewAsset.projectTag}
                                    </div>}
                                    {PreviewAsset.themeTag && <div className="text-light py-1 px-3 storyTag themeTag mr-2 mb-2">
                                        {PreviewAsset.themeTag}
                                    </div>}
                                </div>
                            </div>
                        </div>

                        <div className="container">
                            {
                                struc_data.sort((a, b) => a.order > b.order ? 1 : -1).map((list, index) => {
                                    return (
                                        <div key={index}>
                                            <div className={list.classname}>
                                                {
                                                    list.items.sort((a, b) => a.order > b.order ? 1 : -1).map((item, index2) => {
                                                        return (
                                                            <div key={index2} className={item.classname} style={{ 'padding': '20px ' }}>
                                                                {item.type === 'image' && <div className="d-flex justify-content-center align-items-center"><img alt="" src={item.previewContent} className="img-fluid" /></div>}
                                                                {item.type === 'text' && <div dangerouslySetInnerHTML={{ __html: item.content }}></div>}
                                                                {item.type === 'question' && <div><div className="mb-3 font-weight-bold">{item.question}</div><div dangerouslySetInnerHTML={{ __html: item.content }}></div></div>}

                                                            </div>
                                                        )
                                                    })
                                                }

                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="divided_line"></div>
                                            </div>
                                        </div>

                                    )
                                })
                            }

                        </div>
                    </div>
                </div>}
                <div className="container mt-3 container-customLayout">
                    {this.state.errorMessage && <div className="text-center text-danger">
                        {this.state.errorMessage}
                    </div>}
                    <div className="row mt-3">
                        <div className="col-md-12 d-flex flex-row">
                            <Form GoToPreview={(obj) => this.GoToPreview(obj)} Data={this.state.FormJsonData} FormSubmit={(obj, isAbleToSubmit) => this.checkDataFromForm(obj, isAbleToSubmit)} FileUpload={(file) => this.FileUpload(file)} />
                        </div>
                    </div>
                    <div className="row mt-5 mb-3">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-start w-100">
                                <h3 className="color_113F70">Submit Your Story</h3>
                                <div>
                                    <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                                        <img src="./images/info.png" alt="info" className="icons-md cursor_pointer" />
                                    </OverlayTrigger>

                                </div>
                            </div>
                        </div>
                    </div>
                    <DragDropContext>
                        {/* onDragEnd={this.onDragEnd} */}
                        {/* <Droppable droppableId="droppable" direction="vertical">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                > */}
                        {
                            struc_data.map((list, index) => {
                                return (
                                    // <Draggable key={list.id} draggableId={list.id} index={index}>
                                    //     {(provided, snapshot) => (
                                    //         <div
                                    //             ref={provided.innerRef}
                                    //             {...provided.draggableProps}
                                    //             {...provided.dragHandleProps}
                                    //             style={{
                                    //                 ...getItemStyle(
                                    //                     snapshot.isDragging,
                                    //                     provided.draggableProps.style
                                    //                 )
                                    //             }}
                                    //         >
                                    <div key={index} className={list.classname}>
                                        <div className="position-absolute" style={{ 'top': '-13px', 'right': '0px', 'zIndex': '2' }}>
                                            <a onClick={() => this.deleteRow(index)} className="cursor_pointer"><img src="images/close.png" alt="close" className="icons-sm" /></a>
                                        </div>
                                        {
                                            list.items.sort((a, b) => a.order > b.order ? 1 : -1).map((item, index2) => {
                                                return (
                                                    <div key={index2} className={item.classname}>
                                                        <div className="position-absolute" style={{ 'top': '5px', 'right': '20px', 'zIndex': '9' }}>
                                                            {/* {item.content && item.type == "image" && <a className="cursor_pointer pr-2">
                                                                <img src="images/edit.png" className="icons-sm" /></a>} */}
                                                            {(item.type === "text" || item.type === "question") && <a className="cursor_pointer pr-2" onClick={() => this.hideShowContent(index, index2)}>{item.editor && item.content && <img alt="save" src="images/save.png" className="icons-sm" />}{!item.editor && <img src="images/edit.png" alt="edit" className="icons-sm" />}</a>}
                                                            {item.type && <a onClick={() => this.deleteContent(index, index2)} className="cursor_pointer"><img alt="close" src="images/close.png" className="icons-sm" /></a>}

                                                        </div>
                                                        {item.type && <div className="p-3 w-100 border border-light border-1">
                                                            {item.type == 'image' && <label className="cursor_pointer w-100">
                                                                <img alt="" id={'img' + index + index2} className={'mw-100'} />
                                                                {!item.content && <div className="d-flex align-items-center w-100 justify-content-center color_113F70" style={{ border: '1px dotted grey', height: '250px' }}>
                                                                    <div className="text-center">
                                                                        <img alt="info" src="./images/noimage.png" />
                                                                        <h5 className="font-weight-bold align-middle mt-3">Add Image</h5>
                                                                        <small>File size must be within 1MB to 2MB</small>
                                                                    </div>

                                                                </div>}
                                                                <input type="file" accept=".jpg, .png" onChange={(e) => this.handleImageUpload(e, e.target.files, index, index2)} hidden />
                                                            </label>}
                                                            {item.type == 'text' && item.editor && <div><JoditEditor config={this.state.config} name="editedText" value={item.content} onChange={(e) => this.sunEditorUpdate(e, index, index2)} /><small><span className="text-danger">*</span>Minimum 150 words</small></div>}
                                                            {item.type == 'text' && !item.editor && <div dangerouslySetInnerHTML={{ __html: item.content }}></div>}

                                                            {item.type == 'question' && item.editor && <div><div className="mb-3 font-weight-bold">{item.question}</div><div><small><span className="text-danger">*</span>Minimum 150 words</small></div><JoditEditor config={this.state.config} name="editedText" value={item.content} onChange={(e) => this.sunEditorUpdate(e, index, index2)} /></div>}
                                                            {item.type == 'question' && !item.editor && <div><div className="mb-3 font-weight-bold">{item.question}</div><div dangerouslySetInnerHTML={{ __html: item.content }}></div></div>}
                                                        </div>
                                                        }

                                                        {!item.type && <div className="custom_add_col_container bg-light"><a onClick={() => this.handleAddColItemModal(index, index2)} className="d-block w-100 h-100 text-center cursor_pointer py-4 color_113F70"><img src="images/add.png" alt="add" className="icons-md" /> Columns</a></div>}
                                                    </div>

                                                )
                                            })
                                        }

                                    </div>
                                    /* {provided.placeholder} */
                                    // </div>

                                    // )}

                                    /* </Draggable> */

                                )
                            })
                        }

                        {/* </div> */}
                        {/* )}

                        </Droppable> */}
                    </DragDropContext>
                    <div className="container">
                        <div className="row custom_add_container">
                            <div className="col-md-12 p-0">
                                <a className="d-block w-100 h-100 text-center cursor_pointer py-4 color_113F70 bg-light" onClick={() => this.handleAddRowModal()}><img alt="add" src="images/add.png" className="icons-md" /> Row</a>
                            </div>
                        </div>
                    </div>

                    <div className="row my-3">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-center">
                                <ReCAPTCHA
                                    ref={this.recaptchaRef}
                                    onChange={(e) => this.recaptchaOnChange(e)}
                                    onExpired={this.captchaExpired}
                                    sitekey={process.env.REACT_APP_RECAPTCHA_PRODUCTION_KEY}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-100 mb-5"></div>
                <Modal show={this.state.addColItemsModal} onHide={this.handleAddColItemModal} centered>
                    {/* <Modal.Header closeButton>
                        <Modal.Title>Choose your preference</Modal.Title>
                        </Modal.Header> */}
                    <Modal.Body>
                        <div className="bg-light p-2 d-flex flex-row align-items-center">
                            <div className="mr-2">
                                <img src="images/question.png" className="icons-lg" />
                            </div>
                            <div className="w-100">
                                <p className="mb-2">Answer to 5x questions<span className="text-danger">*</span>:</p>
                                <select className="form-control" onChange={this.addQuestion}>
                                    <option></option>
                                    {
                                        this.state.QuestionList.map((list, index) => {
                                            if (!this.state.NoOfQuestionUsed.includes(list.Question_ID.toString())) {
                                                return (
                                                    <option key={index} value={list.Question_ID}>{list.Question_Details}</option>
                                                );
                                            }

                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="d-flex flex-row mt-2">
                            <div className="w-100">
                                <button onClick={() => this.addImage()} disabled={isAbleToAddImage} className="d-block text-left w-100 btn btn-light font-CaveatBrush-Regular">
                                    <img alt="info" src="images/image.png" className="icons-lg mr-3" />
                                    Add an image <br />
                                    {isAbleToAddImage && <small className="text-danger">Max 5 images</small>}
                                </button>
                            </div>

                        </div>
                        <div className="d-flex flex-row mt-2">
                            <div className="w-100">
                                <button onClick={() => this.addText()} className="d-block text-left w-100 btn btn-light font-CaveatBrush-Regular">
                                    <img alt="text" src="images/text.png" className="icons-lg mr-3" />
                                    More writing...
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-light" onClick={this.handleAddColItemModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.addRowModal} onHide={this.handleAddRowModal} centered>
                    {/* <Modal.Header closeButton>
                        <Modal.Title>Choose your preference</Modal.Title>
                        </Modal.Header> */}
                    <Modal.Body>
                        <div>
                            <a onClick={() => this.addRow(1)} className="d-flex flex-row mb-3 w-100 h-100 btn btn-light justify-content-center py-3 border border-secondary">
                                1 Column
                            </a>
                            <div className="mr-2 w-100 d-none d-md-block">
                                <a onClick={() => this.addRow(2)} className="d-flex flex-row w-100 h-100 btn btn-light justify-content-center border border-secondary">
                                    <div className="w-50 border border-secondary py-3 mr-2">2 Columns</div>
                                    <div className="w-50 border border-secondary py-3 ">2 Columns</div>
                                </a>
                            </div>
                            <div className="mr-2 w-100 d-block d-md-none d-lg-none d-xl-none">
                                <a onClick={() => this.addRow(2)} className="w-100 h-100 btn btn-light justify-content-center border border-secondary">
                                    <div className="border border-secondary py-3 mb-2">2 Columns</div>
                                    <div className="border border-secondary py-3 ">2 Columns</div>
                                </a>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-light" onClick={this.handleAddRowModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.editImageModal} onHide={this.handleEditImageModal} centered>
                    <form >
                        <Modal.Body>
                            <input type="number" className="form-control mb-2" placeholder="width" ref={el => this.Width = el} />
                            <input type="number" className="form-control" placeholder="height" ref={el => this.Height = el} />
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary">
                                Save
                            </button>
                            <button className="btn btn-light" onClick={this.handleEditImageModal}>
                                Cancel
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal>

                <Modal show={this.state.CreateConfirmationModal} onHide={this.handleCreateConfirmationModal}>
                    <form >
                        <Modal.Header>
                            Submit Story Confirmation
                        </Modal.Header>
                        <Modal.Body>
                            Please check carefully all contents before submit story.<br />
                            Your story will be under status <b>Pending Approval</b>  after submitted.
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" disabled={this.state.isSubmitted} className="btn btn-secondary" onClick={this.addNewStory}>
                                Confirm
                            </button>
                            <button type="button" className="btn btn-light" onClick={this.handleCreateConfirmationModal}>
                                Cancel
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal>
                <Toast className="position-fixed" style={{ top: 0, left: "50%", zIndex: 999 }} onClose={this.toggleAlertBox} show={this.state.alertBox} animation={true}>
                    <Toast.Header>
                        Success
                     </Toast.Header>
                    <Toast.Body>
                        <img alt="checked" src="./images/checked.png" className="icons-md" /> You have successfully added new story. Pending for approval
                        <Link to={'/'} className="d-block btn btn-primary mt-3">Home</Link>
                    </Toast.Body>
                </Toast>
            </div >

        );
    }
}

export default CustomLayout;

